module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/img/FairTradeHighGrowth_InlineImage.687dc90c.jpg";